import { useMemo, useState } from 'react'
import placeholder from '../../../../assets/placeholder_artist.jpg';
import { Box, Button, Chip, Skeleton, Stack, Typography } from '@mui/material'
import { Link } from 'react-router-dom';
import styles from './ProducersFocus.module.css'
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import PlayTopTracksButton from '../../../utils/PlayTopTracksButton';
import SettingsInputComponentIcon from '@mui/icons-material/SettingsInputComponent';

var artistNameStyle = {pointerEvents: 'all', color: '#fff', padding: '1rem', m: 1, fontWeight: '700', fontSize: '1.4rem', backgroundColor: '#000000D0',  borderRadius: '16px', '& a' : { textDecoration: 'none'}}
var rankChipStyle = {fontWeight: 900, fontSize: '1rem'}
var buttonsContainerStyle = {backgroundColor: '#000000D0', p: 1, m: 1, borderRadius: '32px', height: '32px', position: 'absolute', bottom: 0, pointerEvents: 'all'}
var buttonStyle = {color: '#fff', p: 1, minWidth: '16px', borderRadius: '32px'}

interface ProducersFocusProps {
    discoverData: any
}

const ProducersFocus = ({discoverData}: ProducersFocusProps) => {
    var [currentIndex, setCurrentIndex] = useState(0)

    const producers = useMemo(() => {
        if (discoverData === null)
            return []

        let dayRanks = discoverData?.rankings
        var producers_ids: any = []
        var allProducers: any = []
        for (const rank of dayRanks) {
            if (rank.track.producers && rank.track.producers.length > 0) {
                rank.track.producers.map((producer: any) => {
                    if (![...allProducers].map((prod: any) => prod._id).includes(producer._id)) 
                        allProducers.push(producer)
                    producers_ids[producer._id] = (producers_ids[producer._id] || 0) + 1
                    return producer
                })
            }
        }

        var items = Object.keys(producers_ids).map(function(key) { return [key, producers_ids[key]] })
        items.sort(function(a, b) { return b[1] - a[1] })
        setCurrentIndex(0)
        return allProducers.sort((a: any, b: any) => items.map((item: any) => item[0]).indexOf(a._id) - items.map((item: any) => item[0]).indexOf(b._id)).map((prod: any, i: number) => {
            return {
                ...prod,
                topTrackCount: items[i][1]
            }
        })
    }, [discoverData])

    const showNextArtist = () => {
        if (currentIndex + 1 === producers.length || currentIndex > producers.length) {
        setCurrentIndex(0)
        } else {
        setCurrentIndex(currentIndex + 1)
        }
    }

    const showPreviousArtist = () => {
        if (currentIndex - 1 === -1 || currentIndex < 0) {
            setCurrentIndex(producers.length - 1)
        } else {
            setCurrentIndex(currentIndex - 1)
        }
    }

    return producers && producers.length > 1
    ? 
        <Box className={styles.producerItem} >
            <Stack className={styles.producerInfos} direction={'column'} >

                <Stack direction={'row'} alignItems={'center'}>
                    <Typography sx={artistNameStyle} ><Link to={`/artist/${producers[currentIndex]?._id}`}>{ producers[currentIndex]?.artist_name }</Link></Typography>
                </Stack>

                <Stack direction={'row'} sx={{position: 'absolute', bottom: 0, p: 1, m: 1, mr: 0, backgroundColor: '#000000D0', borderRadius: '32px', height: '32px'}} alignItems={'center'}>
                    <Chip color={'secondary'} key={currentIndex} label={'#'+ (currentIndex+1)} sx={rankChipStyle}/>
                    <Stack direction={'row'} alignItems={'center'} sx={{mr: 1, display: {xs: 'none', md: 'flex', lg: 'flex'},}}>
                        <SettingsInputComponentIcon sx={{fontSize: '1.2rem', m: 1}}  />
                        <Typography sx={{color: '#fff', fontWeight: 700, fontSize: '1.2rem'}} >{ producers[currentIndex]?.topTrackCount }</Typography>
                    </Stack> 
                </Stack>

                <Stack direction={'row'} sx={{position: 'absolute', bottom: 0, right: 0, p: 1, m: 1, backgroundColor: '#000000D0', borderRadius: '32px', height: '32px', display: {xs: 'flex', md: 'none', lg: 'none'}}} alignItems={'center'}>
                    <Stack direction={'row'} alignItems={'center'} sx={{mr: 1}}>
                        <SettingsInputComponentIcon sx={{fontSize: '1.2rem', m: 1}}  />
                        <Typography sx={{color: '#fff', fontWeight: 700, fontSize: '1.2rem'}} >{ producers[currentIndex]?.topTrackCount }</Typography>
                    </Stack> 
                </Stack>

                <Stack direction={'row'} alignSelf={'center'} sx={buttonsContainerStyle}>
                    <Stack direction={'row'}>
                        <Button onClick={() => showPreviousArtist()} sx={buttonStyle}><NavigateBeforeIcon htmlColor='white'/></Button>
                        <PlayTopTracksButton style={buttonStyle} artistId={producers[currentIndex]?._id} />
                        <Button onClick={() => showNextArtist()} sx={buttonStyle}><NavigateNextIcon htmlColor='white'/></Button>
                    </Stack>
                </Stack>
                
            </Stack>

            <Link to={`/artist/${producers[currentIndex]?._id}`}>
                <img 
                    alt={producers[currentIndex]?.artist_name} 
                    height='100%' 
                    width='100%' 
                    src={producers[currentIndex] && producers[currentIndex]?.avatar_url ? producers[currentIndex]?.avatar_url.replace("cw.png","cc.png").replace("{w}","800").replace("{h}","600") : placeholder} 
                    className="image-cover" />
            </Link>
        </Box>
    :
        <Skeleton variant="rectangular" width={'100%'} height={'100%'} sx={{bgcolor: '#00000048'}}/>
}

export default ProducersFocus